import type { ProductImageType } from 'product/types'
import type { ProductLocations } from 'product/types/ProductLocations'

export interface ProductCardProps {
	productId: string
	lookId: string
	colorId: string
	imageSortCriteria: ProductImageType[]
	dataTestId: string
	isTwoColumnSize?: boolean
	className?: string
	priority?: boolean
	location: ProductLocations
	productListId?: string
	hasProductLabels?: boolean
	hasProductTags?: boolean
	hasColorPicker?: boolean
	hasSizeSheetButton?: boolean
	hasFavoriteButton?: boolean
}

export const enum ColumnLayout {
	OneColumn = 1,
	TwoColumns = 2,
	FourColumns = 4,
}
